"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signWithApiKey = void 0;
const crypto = __importStar(require("crypto"));
const encoding_1 = require("./encoding");
const signWithApiKey = async (input) => {
    const { content, publicKey, privateKey } = input;
    const privateKeyObject = crypto.createPrivateKey({
        // @ts-expect-error -- the key can be a JWK object since Node v15.12.0
        // https://nodejs.org/api/crypto.html#cryptocreateprivatekeykey
        key: (0, encoding_1.convertTurnkeyApiKeyToJwk)({
            uncompressedPrivateKeyHex: privateKey,
            compressedPublicKeyHex: publicKey,
        }),
        format: "jwk",
    });
    const sign = crypto.createSign("SHA256");
    sign.write(Buffer.from(content));
    sign.end();
    return sign.sign(privateKeyObject, "hex");
};
exports.signWithApiKey = signWithApiKey;
//# sourceMappingURL=nodecrypto.js.map